import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import Badge from 'react-bootstrap/Badge'
import { Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import { getFileData } from 'utils/general'

function VerInvestigacion(props) {
	const { investigacion, setQueMostrar } = props

	const handleClose = () => {
		setQueMostrar('')
	}

	// Formatear fecha para mostrar solo el año
	const extraerAnio = (fechaString) => {
		if (!fechaString) return '-'
		return fechaString.substring(0, 4)
	}

	// Obtener información del archivo
	const documentoFileData = getFileData(investigacion.documento?.url)

	// Formatear etiquetas
	const renderEtiquetas = () => {
		if (!investigacion.etiquetas || investigacion.etiquetas.length === 0) {
			return '-'
		}
		return (
			<div className="d-flex flex-wrap gap-1">
				{investigacion.etiquetas.map((etiqueta, index) => (
					<Badge bg="secondary" key={index}>
						{etiqueta.nombre}
					</Badge>
				))}
			</div>
		)
	}

	// Formatear documento
	const renderDocumento = () => {
		if (!investigacion.documento) {
			return '-'
		}
		return (
			<>
				<i className={documentoFileData.icono}></i>
				{' '}
				<a
					href={process.env.REACT_APP_API_URL + investigacion.documento.url}
					target="_blank"
					rel="noopener noreferrer"
				>
					{documentoFileData.nombre}
				</a>
			</>
		)
	}

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true">
			<PanelHeader
				onClick={handleClose}
				iconClass="fa-arrow-left"
				btnText="Atrás"
				text="Ver investigación"
			/>
			<Offcanvas.Body>
				<h1>Datos de la investigación</h1>
				<Row>
					<Col sm={12} md={6}>
						<Table>
							<thead></thead>
							<tbody>
								<tr>
									<th>Id</th>
									<td>{investigacion.id}</td>
								</tr>
								<tr>
									<th>Año de publicación</th>
									<td>{extraerAnio(investigacion.fechaPublicacion)}</td>
								</tr>
								<tr>
									<th>Autor</th>
									<td>{investigacion.autor || '-'}</td>
								</tr>
								<tr>
									<th>Título</th>
									<td>{investigacion.titulo || '-'}</td>
								</tr>
								<tr>
									<th>Planta</th>
									<td>{investigacion.planta || '-'}</td>
								</tr>
								<tr>
									<th>Etiquetas</th>
									<td>{renderEtiquetas()}</td>
								</tr>
								<tr>
									<th>Documento</th>
									<td>{renderDocumento()}</td>
								</tr>
								{investigacion.createdAt && (
									<tr>
										<th>Fecha de creación</th>
										<td>{new Date(investigacion.createdAt).toLocaleDateString('es-PY')}</td>
									</tr>
								)}
								{investigacion.updatedAt && (
									<tr>
										<th>Última actualización</th>
										<td>{new Date(investigacion.updatedAt).toLocaleDateString('es-PY')}</td>
									</tr>
								)}
							</tbody>
						</Table>
					</Col>
				</Row>
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="primary" onClick={handleClose}>
					Ok
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default VerInvestigacion